import { createSelector } from '@reduxjs/toolkit';
import { selectSuburbanFacilitiesValue } from './selectSuburbanFacilitiesValue';
import { selectSuburbanFacilitiesOptions } from './selectSuburbanFacilitiesOptions';

export const selectSuburbanFacilitiesFilter = createSelector(
  [selectSuburbanFacilitiesValue, selectSuburbanFacilitiesOptions],
  (value, options) => ({
    label: 'Дополнительно',
    value,
    options,
  }),
);
